<script>
export default {
  name: 'PageTitle',
  props: {
    hasPreview: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <h1 :class="['page-title', { 'has-preview': hasPreview }]"><slot></slot></h1>
</template>

<style lang="scss" scoped>
@import 'title.scss';
</style>
